module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael E. Uslan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Michael E. Uslan is Originator and Executive Producer of the Batman movie franchise. He was the first instructor to teach an accredited course on comic book folklore at any university. He is the author of "), _c('I', [_vm._v("The Boy Who Loved Batman")]), _vm._v(".")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bXXn46/tc-custom/9781684351855.jpg?1726518898138",
      "alt": "This image is the cover for the book Batman's Batman"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Batman's Batman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("An insider's look at Hollywood and how movies and television shows are made.")])]), _c('p', [_vm._v("In "), _c('i', [_vm._v("Batman's Batman")]), _vm._v(", Michael E. Uslan, executive producer of the Batman movie franchise, offers an insider's look at Hollywood and the process of how movies and television shows go from the drawing board to your screens.")]), _c('p', [_vm._v("Continuing the delightful tale of his adventures begun in "), _c('i', [_vm._v("The Boy Who Loved Batman")]), _vm._v(", Uslan draws on both his successful and less successful attempts to bring ideas to the screen, offering a helpful, honest, and breezily told guide to producing films. From passion to promotion, from the initial pitch to selecting the best partners and packaging, Uslan reveals the 13 qualities essential to would-be producers. ")]), _c('p', [_vm._v("A lively memoir and a valuable glimpse inside Hollywood rarely seen by the public, "), _c('i', [_vm._v("Batman's Batman")]), _vm._v(" is sure to please fans of Michael Uslan and the Batman franchise, but will also prove to be an invaluable resource for any aspiring producers, as he guides readers through the Land of Bilk and Money.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Red Lighting Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0